import axios from 'axios';

async function getDiscordInvitationLink() {
  const response = await axios.get('https://discord.com/api/guilds/988358805664448552/widget.json');

  return response.data;
}

async function uploadFileToS3(signedUrl, data) {
  const response = await axios.put(signedUrl, data);

  return response.data;
}

const miscellaneousService = {
  getDiscordInvitationLink,
  uploadFileToS3,
};

export default miscellaneousService;
